import './tenant-hierarchy.css';
import { ContentHeader, SegmentWithHeader } from '@app/shared';
import { AggregatedConfigurations } from '../products/AggregatedConfigurations';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';
import { OrganisationUnit } from '@app/models';
import { ComponentErrorBoundary } from '@app/utilities';

export function OrganisationUnitDetail({ selectedOu }: { selectedOu: OrganisationUnit }) {
  return (
    selectedOu && (
      <ComponentErrorBoundary>
        <div className={'ui segment basic container'}>
          <div className={'ui segment'}>
            <ContentHeader>{selectedOu.name} OU Details</ContentHeader>
            <ScrollableContentContainer height={'350px'}>
              <JsonViewer value={selectedOu} />
            </ScrollableContentContainer>
          </div>
          <SegmentWithHeader header={'Product Aggregated Configurations'}>
            <ScrollableContentContainer height={'450px'}>
              <AggregatedConfigurations ouId={selectedOu.id} category={'Product'} />
            </ScrollableContentContainer>
          </SegmentWithHeader>
          <SegmentWithHeader header={'Merchant Aggregated Configurations'}>
            <ScrollableContentContainer height={'450px'}>
              <AggregatedConfigurations ouId={selectedOu.id} category={'Merchant'} />
            </ScrollableContentContainer>
          </SegmentWithHeader>
        </div>
      </ComponentErrorBoundary>
    )
  );
}
